"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./CloudWatchLogsClient"), exports);
tslib_1.__exportStar(require("./CloudWatchLogs"), exports);
tslib_1.__exportStar(require("./commands/AssociateKmsKeyCommand"), exports);
tslib_1.__exportStar(require("./commands/CancelExportTaskCommand"), exports);
tslib_1.__exportStar(require("./commands/CreateExportTaskCommand"), exports);
tslib_1.__exportStar(require("./commands/CreateLogGroupCommand"), exports);
tslib_1.__exportStar(require("./commands/CreateLogStreamCommand"), exports);
tslib_1.__exportStar(require("./commands/DeleteDestinationCommand"), exports);
tslib_1.__exportStar(require("./commands/DeleteLogGroupCommand"), exports);
tslib_1.__exportStar(require("./commands/DeleteLogStreamCommand"), exports);
tslib_1.__exportStar(require("./commands/DeleteMetricFilterCommand"), exports);
tslib_1.__exportStar(require("./commands/DeleteQueryDefinitionCommand"), exports);
tslib_1.__exportStar(require("./commands/DeleteResourcePolicyCommand"), exports);
tslib_1.__exportStar(require("./commands/DeleteRetentionPolicyCommand"), exports);
tslib_1.__exportStar(require("./commands/DeleteSubscriptionFilterCommand"), exports);
tslib_1.__exportStar(require("./commands/DescribeDestinationsCommand"), exports);
tslib_1.__exportStar(require("./pagination/DescribeDestinationsPaginator"), exports);
tslib_1.__exportStar(require("./commands/DescribeExportTasksCommand"), exports);
tslib_1.__exportStar(require("./commands/DescribeLogGroupsCommand"), exports);
tslib_1.__exportStar(require("./pagination/DescribeLogGroupsPaginator"), exports);
tslib_1.__exportStar(require("./commands/DescribeLogStreamsCommand"), exports);
tslib_1.__exportStar(require("./pagination/DescribeLogStreamsPaginator"), exports);
tslib_1.__exportStar(require("./commands/DescribeMetricFiltersCommand"), exports);
tslib_1.__exportStar(require("./pagination/DescribeMetricFiltersPaginator"), exports);
tslib_1.__exportStar(require("./commands/DescribeQueriesCommand"), exports);
tslib_1.__exportStar(require("./commands/DescribeQueryDefinitionsCommand"), exports);
tslib_1.__exportStar(require("./commands/DescribeResourcePoliciesCommand"), exports);
tslib_1.__exportStar(require("./commands/DescribeSubscriptionFiltersCommand"), exports);
tslib_1.__exportStar(require("./pagination/DescribeSubscriptionFiltersPaginator"), exports);
tslib_1.__exportStar(require("./commands/DisassociateKmsKeyCommand"), exports);
tslib_1.__exportStar(require("./commands/FilterLogEventsCommand"), exports);
tslib_1.__exportStar(require("./pagination/FilterLogEventsPaginator"), exports);
tslib_1.__exportStar(require("./commands/GetLogEventsCommand"), exports);
tslib_1.__exportStar(require("./pagination/GetLogEventsPaginator"), exports);
tslib_1.__exportStar(require("./commands/GetLogGroupFieldsCommand"), exports);
tslib_1.__exportStar(require("./commands/GetLogRecordCommand"), exports);
tslib_1.__exportStar(require("./commands/GetQueryResultsCommand"), exports);
tslib_1.__exportStar(require("./commands/ListTagsLogGroupCommand"), exports);
tslib_1.__exportStar(require("./commands/PutDestinationCommand"), exports);
tslib_1.__exportStar(require("./commands/PutDestinationPolicyCommand"), exports);
tslib_1.__exportStar(require("./commands/PutLogEventsCommand"), exports);
tslib_1.__exportStar(require("./commands/PutMetricFilterCommand"), exports);
tslib_1.__exportStar(require("./commands/PutQueryDefinitionCommand"), exports);
tslib_1.__exportStar(require("./commands/PutResourcePolicyCommand"), exports);
tslib_1.__exportStar(require("./commands/PutRetentionPolicyCommand"), exports);
tslib_1.__exportStar(require("./commands/PutSubscriptionFilterCommand"), exports);
tslib_1.__exportStar(require("./commands/StartQueryCommand"), exports);
tslib_1.__exportStar(require("./commands/StopQueryCommand"), exports);
tslib_1.__exportStar(require("./commands/TagLogGroupCommand"), exports);
tslib_1.__exportStar(require("./commands/TestMetricFilterCommand"), exports);
tslib_1.__exportStar(require("./commands/UntagLogGroupCommand"), exports);
tslib_1.__exportStar(require("./pagination/Interfaces"), exports);
tslib_1.__exportStar(require("./models/index"), exports);
//# sourceMappingURL=index.js.map